export const url = {
    devUrl: 'http://www.trend-lab.cn',
    testUrl: 'http://fnb-qrcode.trendlab.cc',
    proUrl: 'http://fnb-qrcode.trendlab.ai'
}